<template>
  <div>
    <v-dialog v-model="error" width="500">
      <v-card>
        <v-card-title class="headline red accent-3" primary-title>
          Warning Message
        </v-card-title>

        <v-card-text>
          {{ errorMsg }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-3" flat @click="setErrorZero">close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div>
      <v-snackbar
        v-model="snackbar"
        :right="x === 'right'"
        :timeout="timeout"
        :top="y === 'top'"
      >
        {{ errorMsg }}
        <v-btn color="pink" flat @click="snackbar = false">Close</v-btn>
      </v-snackbar>
    </div>

    <v-toolbar flat color="white">
      <v-toolbar-title>Package UiCategory</v-toolbar-title>
    </v-toolbar>
    <v-card>
      <v-card-text>
        <v-layout row>
          <v-spacer></v-spacer>
          <v-container grid-list-md>
            <v-layout row>
              <v-flex xs12 sm6 md4>
                <v-select
                  v-model="editedItem.package_id"
                  :items="indexData.packages.data"
                  v-if="indexData.packages"
                  item-text="name"
                  item-value="id"
                  box
                  label="Select Package"
                ></v-select>
                <v-btn color="blue darken-1" flat @click="show">Show</v-btn>
                <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
              </v-flex>
            </v-layout>
            <v-spacer></v-spacer>
          </v-container>
        </v-layout>
      </v-card-text>
    </v-card>

    <div v-if="loadData">
      <v-data-table
        v-model="editedItem.uiCategories"
        :headers="urlHeaders"
        :items="indexData.uiCategory"
        item-key="id"
        :search="search"
        select-all
        class="elevation-1"
        show-select
        hide-actions
      >
        <template v-slot:items="props">
          <td>
            <v-checkbox
              v-model="props.selected"
              selected
              primary
              hide-details
            ></v-checkbox>
          </td>
          <td class="text-xs-left">{{ props.item.id }}</td>
          <td class="text-xs-left">{{ props.item.name }}</td>
        </template>
      </v-data-table>
      <v-layout row v-if="indexData.assignedPackageUiCategories">
        <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click="save">Save</v-btn>
      </v-layout>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from "vuex";

  export default {
    data: () => ({
      dialog: false,
      search: "",
      snackbar: false,
      y: "top",
      x: "right",
      timeout: 4000,
      apiUrl: "package.ui-category",
      urlHeaders: [
        { text: "ID", align: "left", value: "id", sortable: true },
        { text: "UiCategory Name", align: "left", value: "name", sortable: false },
      ],
      editedIndex: -1,
      previousData: [],
      editedItem: {
        uiCategories: [],
        package_id: "",
      },
      defaultItem: {
        previousData: [],
        uiCategories: [],
        package_id: "",
      },
    }),

    computed: {
      ...mapGetters([
        "isLoggedIn",
        "indexData",
        "error",
        "statusCode",
        "errorMsg",
      ]),
      formTitle() {
        return this.editedIndex === -1
          ? "Assign Url To Role"
          : "Edit Url To Role";
      },
      loadData() {
        if (this.indexData.assignedPackageUiCategories) {
          return this.getSelected();
        } else {
          return false;
        }
      },
    },

    watch: {
      dialog(val) {
        val || this.close();
      },
    },

    created() {
      this.initialize();
    },

    methods: {
      initialize() {
        this.$store.dispatch("setIndexData", [this.apiUrl]);
      },
      getSelected() {
        this.editedItem.uiCategories = this.indexData.assignedPackageUiCategories;
        return true;
      },

      setErrorZero() {
        this.$store.dispatch("setErrorZero");
      },

      close() {
        this.dialog = false;
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        }, 300);
      },

      show() {
        // console.log(this.editedItem.package_id);
        if (this.editedIndex > -1) {
          this.$store.dispatch("indexData", [
            "assign.package.ui-category",
            this.editedItem.package_id,
          ]);
        } else {
          this.$store.dispatch("indexData", [
            "assign.package.ui-category",
            this.editedItem.package_id,
          ]);
        }
      },
      save() {
        // console.log(this.editedItem.selected)
        // console.log(this.indexData.assignedUrlsToRole)
        if (this.editedIndex > -1) {
          this.$store.dispatch("storeOrUpdate", [this.apiUrl, this.editedItem]);
        } else {
          this.$store.dispatch("storeOrUpdate", [this.apiUrl, this.editedItem]);
        }
        this.snackbar = true;
        this.close();
      },
    },
  };
</script>
<style scoped>
  .tbl-border {
    border: 1px solid #000;
  }
  .table-th {
    border: 1px solid #000;
  }
</style>
